import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { Button } from './ui/button';
import { Checkbox } from './ui/checkbox';
import { Users, ChevronDown } from 'lucide-react';

export function UserMultiSelect({ users, value = [], onChange, placeholder = 'Select team members', testId = 'user-multi-select' }) {
  const toggle = (id) => onChange(value.includes(id) ? value.filter((v) => v !== id) : [...value, id]);
  const names = users.filter((u) => value.includes(u.id)).map((u) => u.full_name.split(' ')[0]);
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" className="w-full justify-between font-normal h-9" data-testid={testId}>
          <span className="flex items-center gap-2 truncate">
            <Users className="w-4 h-4 text-slate-400 shrink-0" />
            {names.length ? names.join(', ') : <span className="text-slate-400">{placeholder}</span>}
          </span>
          <ChevronDown className="w-4 h-4 text-slate-400 shrink-0" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-64 max-h-72 overflow-y-auto p-2" align="start">
        {users.map((u) => (
          <label key={u.id} className="flex items-center gap-2 px-2 py-1.5 rounded-md hover:bg-slate-50 cursor-pointer text-sm" data-testid={`${testId}-option-${u.id}`}>
            <Checkbox checked={value.includes(u.id)} onCheckedChange={() => toggle(u.id)} />
            {u.full_name}
          </label>
        ))}
      </PopoverContent>
    </Popover>
  );
}
